import $ from "jquery";
import Marionette from "backbone.marionette";

export default Marionette.View.extend({
    template: false,

    ui: {
        autoApplyBtn: ".js-auto-apply",
    },

    events: {
        "click @ui.autoApplyBtn": "onAutoApplySelection",
    },

    onRender() {
        this.$el.show();
    },

    onAutoApplySelection(event) {
        event.preventDefault();

        this.ui.autoApplyBtn.removeClass("selected");
        $(event.currentTarget).addClass("selected");

        const autoApply = Number(event.currentTarget.dataset.autoapply);

        $.ajax({
            type: "PATCH",
            url: "/api/hire/v1/preferences/",
            data: JSON.stringify({
                auto_apply_enabled: autoApply,
            }),
            dataType: "json",
            contentType: "application/json",
        }).always(() => {
            const callback = this.options.handleAutoApplyChange;
            const enabled = autoApply > 0;

            if (callback) {
                callback(enabled);
            }
        });
    },
});
